import React, { useEffect, useRef } from 'react';
import lightGallery from 'lightgallery';
import type { LightGallery } from 'lightgallery/lightgallery';
import { Article } from '../../interfaces/data/article';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import './ArticleContent.css';
import { Contact } from '../contact/Contact';

// styles (required)
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';

interface IProps {
    article: Article | undefined;
}

export function ArticleContent(props: IProps) {
    const headerImagePath = props.article?.summary.headerImage ?? "";
    const contentRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!contentRef.current) return;

        const galleries = contentRef.current.querySelectorAll('.lightgallery');

        const instances: LightGallery[] = [];

        galleries.forEach((el) => {
            const instance = lightGallery(el as HTMLElement, {
                plugins: [lgThumbnail],
                selector: 'a',
                thumbnail: true
            });

            instances.push(instance);
        });

        return () => {
            instances.forEach(instance => instance.destroy());
        };
    }, [props.article?.content]); // re-run when content changes
    
    const articleImg = headerImagePath
        ? <img className="article-header-image" alt={props.article?.summary.title} src={`/${headerImagePath}`} />
        : null;

    return (
        <article className="article">
            <div className="article-container border-full border-light">
                <div className="article-container border-full border-dark">
                    <div className="article-content">
                        <div className="article-header">
                            <h2 className="article-header-text">{props.article?.summary.title}</h2>
                        </div>
                        <SimpleBar className="article-content-text">
                            <div className="article-contact">
                                <div className="article-content-text-container">
                                    {articleImg}
                                    <div
                                        ref={contentRef}
                                        dangerouslySetInnerHTML={{ __html: props.article?.content ?? "" }}></div>
                                </div>
                                <Contact />
                            </div>
                        </SimpleBar>
                    </div>
                </div>
            </div>
        </article>
    );
}